const getInsightURL = (accountId: string) => {
  return `/insight/accounts/${accountId}/risk`;
};

export default getInsightURL;
